<div class="add-edit-vehicle-container mat-dialog-custom">
  <div class="title-container">
    @if (!editMode) {
      <h1 class="title" i18n>Add Vehicle</h1>
    } @else {
      <h1 class="title" i18n>Edit Your Vehicle</h1>
    }
    <button
      id="closeAddVehicle"
      class="close button button-link"
      type="button"
      aria-label="close"
      (click)="onClose()"
      i18n-aria-label
    >
      <svg-icon src="/assets/icons/close.svg" alt="close" i18n-alt />
    </button>
  </div>
  @if (vehicle) {
    <div class="body-container">
      @if (shouldShowStartScreen) {
        <div class="start-screen">
          <div class="options">
            <!-- Images cannot have a dynamic source for markup inline -->
            @if (isOffRoad) {
              <h4>
                <img alt="Polaris Logo." ngSrc="/assets/icons/offroad/small-logo.svg" i18n-alt />
                <span i18n>Polaris Vehicle Owners</span>
              </h4>
              <div>
                <p i18n>
                  Add a Polaris vehicle with a RIDE COMMAND touchscreen by signing in to your account on the vehicle.
                </p>
                <img alt="ORV device display icon." ngSrc="/assets/icons/offroad/display.svg" i18n-alt />
              </div>
            } @else if (isSlingshot) {
              <h4>
                <img alt="Slingshot Logo." ngSrc="/assets/icons/slingshot/small-logo.svg" i18n-alt />
                <span i18n>Slingshot Vehicle Owners</span>
              </h4>
              <div>
                <p i18n>
                  Add a Slingshot vehicle with a RIDE COMMAND touchscreen by signing in to your account on the vehicle.
                </p>
                <img alt="Slingshot device display icon." ngSrc="/assets/icons/slingshot/display.svg" i18n-alt />
              </div>
            } @else if (isIndian) {
              <h4>
                <img alt="Indian Motorcycle Logo." ngSrc="/assets/icons/indian/small-logo.svg" i18n-alt />
                <span i18n>Indian Vehicle Owners</span>
              </h4>
              <div>
                <p i18n>
                  Add an Indian bike with a RIDE COMMAND touchscreen by signing in to your account on the bike.
                </p>
                <img alt="Indian Motorcycle device display icon." ngSrc="/assets/icons/indian/display.svg" i18n-alt />
              </div>
            }
            <div>
              <p>
                <ng-container i18n>Add a </ng-container>{{ vehicleType }}
                <ng-container i18n> by VIN to access owners manuals,</ng-container> {{ vehicleType }}
                <ng-container i18n> specs, maintenance schedules, and more.</ng-container>
              </p>
              <button id="addVehicleByVinBtn" class="button secondary-button" type="button" (click)="setAddByVin()">
                <span i18n>Add by VIN</span>
              </button>
            </div>
          </div>
          <span i18n>Don't have a VIN? </span>
          <a id="addByModel" class="helper-inline-block" href="javascript:void(0);" (click)="setAddByCategory()" i18n
            >Add by Make/Model</a
          >
        </div>
      }
      @if (shouldShowCategorySelect) {
        <div class="vehicle-categories">
          @for (category of vehicleCategories; track $index) {
            <button
              class="category"
              type="button"
              [id]="'selectCategory' + category.name | removewhitespace"
              (click)="selectCategory(category.id)"
            >
              <img
                [ngSrc]="vehicleImageMap[category.id]"
                [srcset]="vehicleSrcSetMap[category.id]"
                [alt]="category.name"
              />
              <h4>{{ category.name }}</h4>
            </button>
          }
        </div>
      }
      @if (shouldShowSnoMakeSelect) {
        <div class="snow-makes">
          @for (make of vehicleMakes; track $index) {
            <button
              type="button"
              [id]="'selectMake' + make.name | removewhitespace"
              [class]="'category ' + make.imageId"
              (click)="selectMake(make.id, true)"
            >
              <img [ngSrc]="vehicleMakeImageMap[make.id]" [srcset]="vehicleMakeSrcSetMap[make.id]" [alt]="make.name" />
            </button>
          }
        </div>
      }
      @if (shouldShowForm) {
        <form
          #vehicleForm="ngForm"
          id="vehicleForm"
          class="form-body"
          name="vehicleForm"
          novalidate
          (submit)="saveVehicle(vehicleForm)"
        >
          @if (shouldShowYearModel && !isPolarisVin) {
            <mat-form-field class="form-field">
              <mat-label i18n>Category</mat-label>
              <mat-select
                #categorySelect
                id="category"
                name="category"
                required
                [(ngModel)]="vehicle.categoryId"
                (selectionChange)="selectCategory(categorySelect.value)"
              >
                @for (category of vehicleCategories; track $index) {
                  <mat-option [id]="category.name | removewhitespace" [value]="category.id"
                    >{{ category.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (shouldShowYearModel && isPolarisVin) {
            <mat-form-field class="form-field">
              <mat-label i18n>Category</mat-label>
              <mat-select id="category" name="category" disabled [value]="vehicle.category">
                <mat-option [value]="vehicle.category">{{ vehicle.category }}</mat-option>
              </mat-select>
            </mat-form-field>
          }

          @if (shouldShowYearModel && !isPolarisVin) {
            <mat-form-field class="form-field">
              <mat-label i18n>Make</mat-label>
              <mat-select
                #makeSelect
                id="make"
                name="make"
                required
                [disabled]="!vehicle.categoryId"
                [(ngModel)]="vehicle.makeId"
                (selectionChange)="selectMake(makeSelect.value)"
              >
                @for (make of vehicleMakes; track $index) {
                  <mat-option [id]="make.name | removewhitespace" [value]="make.id">
                    {{ make.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (shouldShowYearModel && isPolarisVin) {
            <mat-form-field class="form-field">
              <mat-label i18n>Make</mat-label>
              <mat-select id="make" name="make" disabled [value]="vehicle.make">
                <mat-option [value]="vehicle.make">{{ vehicle.make }}</mat-option>
              </mat-select>
            </mat-form-field>
          }

          @if (shouldShowYearModel && !isPolarisVin) {
            <mat-form-field class="form-field">
              <mat-label i18n>Year</mat-label>
              <mat-select
                #yearSelect
                id="year"
                name="year"
                required
                [disabled]="!vehicle.makeId"
                [(ngModel)]="vehicle.modelYear"
                (selectionChange)="selectYear(yearSelect.value)"
              >
                @for (year of vehicleYears; track $index) {
                  <mat-option [id]="year | string: 10" [value]="year">{{ year }} </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (shouldShowYearModel && isPolarisVin) {
            <mat-form-field class="form-field">
              <mat-label i18n>Year</mat-label>
              <mat-select id="year" name="year" disabled [value]="vehicle.modelYear">
                <mat-option [value]="vehicle.modelYear">{{ vehicle.modelYear }}</mat-option>
              </mat-select>
            </mat-form-field>
          }

          @if (shouldShowYearModel && !isPolarisVin) {
            <mat-form-field class="form-field">
              <mat-label i18n>Model</mat-label>
              <mat-select
                #modelSelect
                id="model"
                name="model"
                required
                [disabled]="!vehicle.modelYear"
                [(ngModel)]="vehicle.modelId"
                (selectionChange)="selectModel(modelSelect.value)"
              >
                @for (model of vehicleModels; track $index) {
                  <mat-option [id]="model.name | removewhitespace" [value]="model.id">{{ model.name }} </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (shouldShowYearModel && isPolarisVin) {
            <mat-form-field class="form-field">
              <mat-label i18n>Model</mat-label>
              <mat-select id="model" name="model" disabled [value]="vehicle.model">
                <mat-option [value]="vehicle.model">{{ vehicle.model }}</mat-option>
              </mat-select>
            </mat-form-field>
          }

          @if (addingPolarisMake && !vehicle.vin) {
            <div class="warning">
              <svg-icon src="/assets/icons/warning.svg" alt="enter-vin" i18n-alt />
              <span i18n>Enter VIN to enable additional Garage features</span>
            </div>
          }

          <mat-form-field class="form-field">
            <mat-label i18n>Vehicle Identification Number (VIN)</mat-label>
            <input
              #vehicleVIN="ngModel"
              id="vehicleVIN"
              class="vin-input"
              name="vehicleVIN"
              matInput
              rdxUppercase
              [(ngModel)]="vehicle.vin"
              (input)="vinChange()"
              (focusout)="vinBlur()"
            />
          </mat-form-field>

          @if (vehicle.vin && !isDuplicateVin && isVinFinal && !isGettingVinInfo && !isPolarisVin && shouldShowVin) {
            <div class="warning">
              <svg-icon src="/assets/icons/warning.svg" alt="enter-vin" i18n-alt />
              <span class="helper-bold" i18n>VIN not recognized.</span>
              @if (!editMode) {
                <div i18n>
                  If you are trying to add a Polaris vehicle, please double check the VIN and retry or click continue.
                </div>
              } @else {
                <div i18n>
                  If you are trying to edit a Polaris vehicle, please double check the VIN and retry or click continue.
                </div>
              }
            </div>
          }

          @if (isDuplicateVin) {
            <div class="warning">
              <svg-icon src="/assets/icons/warning.svg" alt="enter-vin" i18n-alt />
              @if (vehicle.brand === 'indian') {
                <span id="duplicateIndianVinError" class="material-error" i18n
                  >This bike is already in your garage.</span
                >
              }
              @if (vehicle.brand !== 'indian') {
                <span id="duplicateVinError" class="material-error" i18n>This vehicle is already in your garage.</span>
              }
            </div>
          }

          <mat-form-field class="form-field">
            <mat-label i18n>Nickname</mat-label>
            <input
              id="vehicleName"
              name="name"
              matInput
              maxlength="50"
              [disabled]="isGettingVinInfo"
              [(ngModel)]="vehicle.name"
            />
          </mat-form-field>

          @if (vehicleImageUrl && !isDuplicateVin) {
            <div class="side-container">
              <img id="vehicleImage" class="vehicle-image" alt="Vehicle Image" [ngSrc]="vehicleImageUrl" i18n-alt />
              <div>
                <p id="vehicleModelImage" class="vehicle-subtext">{{ vehicle.modelYear }} {{ vehicle.model }}</p>
                <p class="helper-bold">{{ vehicle.name }}</p>
              </div>
            </div>
          }

          <div class="submit-area">
            @if (!isVinFinal || isGettingVinInfo || isPolarisVin || !shouldShowVin) {
              <button
                id="add"
                class="button primary-button"
                type="submit"
                rdxAnalytics="Edit Vehicle"
                [disabled]="isGettingVinInfo || isDuplicateVin || isAddingVehicle"
              >
                <span class="title">{{ editMode ? saveButtonI18n : addButtonI18n }}</span>
              </button>
            }
            @if (isVinFinal && !isGettingVinInfo && !isPolarisVin && shouldShowVin) {
              <button
                id="add"
                class="button primary-button"
                type="submit"
                rdxAnalytics="Edit Vehicle"
                [disabled]="isGettingVinInfo || isDuplicateVin || isAddingVehicle"
              >
                <span class="title" i18n>Continue</span>
              </button>
            }
            <button
              id="cancelVehicleAdd"
              class="button secondary-button"
              type="button"
              rdxAnalytics="Cancel Vehicle Edit"
              (click)="onClose()"
              i18n
            >
              Cancel
            </button>
            @if (editMode) {
              <button
                id="delete"
                class="button secondary-button delete-button"
                type="button"
                aria-label="delete"
                rdxAnalytics="Delete Vehicle"
                (click)="deleteVehicle()"
                i18n-aria-label
              >
                <svg-icon src="/assets/icons/trash.svg" alt="Delete" i18n-alt />
              </button>
            }
            <div class="form-info helper-italic" i18n>*Required Fields</div>
          </div>
          @if (!editMode && shouldShowVin && !isPolarisVin) {
            <div class="show-vin-add-by-model">
              <span i18n>Don't have a VIN? </span>
              <a
                id="addByModel"
                class="helper-inline-block"
                href="javascript:void(0);"
                (click)="setAddByMakeModel()"
                i18n
                >Add by Make/Model</a
              >
            </div>
          }
        </form>
      }
    </div>
  }
</div>
